import React from "react";
import styles from "./styles.module.scss";
export const BTN_VARIANTS = {
  transparent: "transparent",
  primary: "primary",
  secondary: "secondary",
};
const Button = ({
  className,
  variant,
  onClick = () => {},
  children,
  ...rest
}) => {
  return (
    <button
      className={`${styles.btn} ${styles[variant]} ${className}`}
      onClick={onClick}
      {...rest}
    >
      {children}
    </button>
  );
};

export default Button;
